<template>
  <nav class="station-list">
    <ul
      ref="listEl"
      class="station-list__list"
      tabindex="-1"
      :aria-label="props.ariaLabel || $t('stationList.ariaLabelDefault')"
    >
      <slot />
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Aria label */
    ariaLabel?: string
  }>(),
  {
    ariaLabel: undefined,
  },
)

const listEl = useTemplateRef<HTMLDivElement>('listEl')

/**
 * Focus the list element
 */
const focus = () => {
  if (!listEl.value) {
    return
  }

  listEl.value.focus({
    preventScroll: true,
  })
}

defineExpose({
  focus,
})
</script>

<style lang="scss" scoped>
.station-list {
  container-type: inline-size;
  display: block;
  width: 100%;

  &:not(:first-child) {
    margin-top: var(--block-spacing-vertical-normal);
  }

  &:not(:last-child) {
    margin-bottom: var(--block-spacing-vertical-normal);
  }

  &__list {
    --num-columns: 1;

    display: grid;
    grid-template-columns: repeat(var(--num-columns), 1fr);
    row-gap: calc(var(--block-spacing-vertical-normal) * 1.5);
    column-gap: var(--block-spacing-horizontal-small);
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;

    &:focus-visible {
      outline: unset;
    }

    @container (min-width: 700px) {
      --num-columns: 2;
    }

    @container (min-width: 1050px) {
      --num-columns: 3;
    }

    @container (min-width: 1400px) {
      --num-columns: 4;
    }
  }
}
</style>
